export default {
  dropboxFileMaxSize: 5 * 1000 ** 4, // 5 TB
};
